import { render, staticRenderFns } from "./Calculate.vue?vue&type=template&id=496baf8b&scoped=true&lang=pug"
import script from "./Calculate.vue?vue&type=script&lang=js"
export * from "./Calculate.vue?vue&type=script&lang=js"
import style0 from "./Calculate.vue?vue&type=style&index=0&id=496baf8b&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496baf8b",
  null
  
)

export default component.exports